import { inject, Injectable, Type } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { EpSelfEnrolmentFlowStepEnum } from './ep-self-enrolment-flow-step.enum';
import { EpSelfEnrolmentEmployerInfoComponent } from './ep-self-enrolment-employer-info/ep-self-enrolment-employer-info.component';
import { EpSelfEnrolmentContactPersonnelComponent } from './ep-self-enrolment-contact-personnel/ep-self-enrolment-contact-personnel.component';

@Injectable()
export class EpSelfEnrolmentNavService {
  private router = inject(Router);

  public canDeactivate = false;

  private StepComponents: Record<EpSelfEnrolmentFlowStepEnum, Type<any>> = {
    [EpSelfEnrolmentFlowStepEnum.EmployerInformation]: EpSelfEnrolmentEmployerInfoComponent,
    [EpSelfEnrolmentFlowStepEnum.ContactPersonnel]: EpSelfEnrolmentContactPersonnelComponent
  };

  private _currentStep = new BehaviorSubject<EpSelfEnrolmentFlowStepEnum>(
    EpSelfEnrolmentFlowStepEnum.EmployerInformation
  );
  public currentStep$ = this._currentStep as Observable<EpSelfEnrolmentFlowStepEnum>;

  public currentStepComponent$ = this.currentStep$.pipe(map(currentStep => this.StepComponents[currentStep]));

  public goForward(): void {
    this.currentStep$.pipe(take(1)).subscribe(step => this._currentStep.next(step + 1));
  }

  public goBack(): void {
    this.currentStep$.pipe(take(1)).subscribe(step => this._currentStep.next(step - 1));
  }
}
